export default __webpack_public_path__ + "static/media/Subir.cd084c08.svg";